/**
 * @generated SignedSource<<8f3bf945abdbac2fc2430a3b375b5102>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberGroupKind = "custom" | "default" | "role" | "test_user" | "%future added value";
export type MemberGroupOrderByFieldFilter = "created_on" | "name" | "%future added value";
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type MemberGroupOrderByInput = {
  direction: OrderDirection;
  field: MemberGroupOrderByFieldFilter;
};
export type AdminGroupsListPageQuery$variables = {
  after?: string | null;
  before?: string | null;
  first?: number | null;
  kinds?: ReadonlyArray<MemberGroupKind> | null;
  last?: number | null;
  orderBy?: MemberGroupOrderByInput | null;
  organizationId: string;
  search?: string | null;
};
export type AdminGroupsListPageQuery$data = {
  readonly organization: {
    readonly defaultMemberGroup?: {
      readonly " $fragmentSpreads": FragmentRefs<"CreateMemberGroupButtonFragment" | "CreateMemberGroupModalFragment">;
    };
    readonly " $fragmentSpreads": FragmentRefs<"AdminGroupsList_PaginationFragment">;
  } | null;
};
export type AdminGroupsListPageQuery = {
  response: AdminGroupsListPageQuery$data;
  variables: AdminGroupsListPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "kinds"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v8 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "organizationId"
  }
],
v9 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v10 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v11 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v12 = {
  "kind": "Variable",
  "name": "kinds",
  "variableName": "kinds"
},
v13 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v14 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v15 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v18 = [
  (v9/*: any*/),
  {
    "kind": "Literal",
    "name": "allMemberGroups",
    "value": true
  },
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSystem",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v27 = [
  (v19/*: any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v21/*: any*/)
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v31 = [
  (v12/*: any*/),
  (v15/*: any*/)
],
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminGroupsListPageQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v8/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberGroup",
                "kind": "LinkedField",
                "name": "defaultMemberGroup",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CreateMemberGroupButtonFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CreateMemberGroupModalFragment"
                  }
                ],
                "storageKey": null
              },
              {
                "args": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "AdminGroupsList_PaginationFragment"
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v6/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v7/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "AdminGroupsListPageQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v8/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v16/*: any*/),
          (v17/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberGroup",
                "kind": "LinkedField",
                "name": "defaultMemberGroup",
                "plural": false,
                "selections": [
                  (v17/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v18/*: any*/),
                "concreteType": "MemberGroupNodeConnection",
                "kind": "LinkedField",
                "name": "memberGroups",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberGroupNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v20/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "organizationId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "avatarURL",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberGroupMembershipNodeConnection",
                            "kind": "LinkedField",
                            "name": "unassignedMembers",
                            "plural": false,
                            "selections": (v27/*: any*/),
                            "storageKey": null
                          },
                          (v16/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/),
                          {
                            "alias": null,
                            "args": (v31/*: any*/),
                            "concreteType": "MemberGroupNodeConnection",
                            "kind": "LinkedField",
                            "name": "childrenGroups",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MemberGroupNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MemberGroup",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      (v23/*: any*/),
                                      (v25/*: any*/),
                                      (v21/*: any*/),
                                      (v26/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "parentMemberGroupId",
                                        "storageKey": null
                                      },
                                      (v22/*: any*/),
                                      (v28/*: any*/),
                                      (v24/*: any*/),
                                      (v29/*: any*/),
                                      (v30/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MemberGroup",
                                        "kind": "LinkedField",
                                        "name": "parentMemberGroup",
                                        "plural": false,
                                        "selections": [
                                          (v21/*: any*/),
                                          (v17/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MemberGroupMembershipNodeConnection",
                                        "kind": "LinkedField",
                                        "name": "memberGroupMemberships",
                                        "plural": false,
                                        "selections": (v27/*: any*/),
                                        "storageKey": null
                                      },
                                      (v16/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v20/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PageInfoObjectType",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                  (v32/*: any*/),
                                  (v33/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v31/*: any*/),
                            "filters": [],
                            "handle": "connection",
                            "key": "AdminGroupsListRow__childrenGroups",
                            "kind": "LinkedHandle",
                            "name": "childrenGroups"
                          },
                          {
                            "alias": "sampleMemberships",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 3
                              }
                            ],
                            "concreteType": "MemberGroupMembershipNodeConnection",
                            "kind": "LinkedField",
                            "name": "memberGroupMemberships",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MemberGroupMembershipNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MemberGroupMembership",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                          (v17/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "firstName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "lastName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "fullName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "avatar",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isTest",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "memberGroupMemberships(first:3)"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfoObjectType",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      (v32/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      },
                      (v33/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v18/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "AdminGroupsList__memberGroups",
                "kind": "LinkedHandle",
                "name": "memberGroups"
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2041a84dfdb5bbf641abb242332fecf3",
    "id": null,
    "metadata": {},
    "name": "AdminGroupsListPageQuery",
    "operationKind": "query",
    "text": "query AdminGroupsListPageQuery(\n  $organizationId: ID!\n  $first: Int\n  $after: String\n  $last: Int\n  $before: String\n  $search: String\n  $orderBy: MemberGroupOrderByInput\n  $kinds: [MemberGroupKind!]\n) {\n  organization: node(id: $organizationId) {\n    __typename\n    ... on Organization {\n      defaultMemberGroup {\n        ...CreateMemberGroupButtonFragment\n        ...CreateMemberGroupModalFragment\n        id\n      }\n      ...AdminGroupsList_PaginationFragment_7Tgdc\n    }\n    id\n  }\n}\n\nfragment AdminGroupsListRowFragment_1NY8Tm on MemberGroup {\n  id\n  name\n  color\n  kind\n  isSystem\n  createdAt\n  productId\n  organizationId\n  description\n  avatarURL\n  unassignedMembers {\n    totalCount\n  }\n  ...UnassignedMemberRowFragment\n  ...DeleteMemberGroupButtonFragment\n  ...CreateMemberGroupButtonFragment\n  ...EditMemberGroupButtonFragment\n  ...MemberGroupTagFragment\n  ...MemberGroupVisibilityChipFragment\n  ...MemberGroupKindChipFragment\n  childrenGroups(kinds: $kinds, search: $search) {\n    edges {\n      node {\n        id\n        ...GroupsListChildGroupRowFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  sampleMemberships: memberGroupMemberships(first: 3) {\n    totalCount\n    edges {\n      node {\n        id\n        user {\n          id\n          firstName\n          lastName\n          ...ProfileAvatarFragment\n          ...ProfileListModalListItemFragment\n        }\n      }\n    }\n  }\n}\n\nfragment AdminGroupsList_PaginationFragment_7Tgdc on Organization {\n  id\n  memberGroups(first: $first, after: $after, last: $last, before: $before, search: $search, orderBy: $orderBy, kinds: $kinds, allMemberGroups: true) {\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        ...AdminGroupsListRowFragment_1NY8Tm\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      startCursor\n      hasNextPage\n      hasPreviousPage\n    }\n  }\n}\n\nfragment CreateMemberGroupButtonFragment on MemberGroup {\n  ...CreateMemberGroupModalFragment\n}\n\nfragment CreateMemberGroupModalFragment on MemberGroup {\n  id\n}\n\nfragment DeleteMemberGroupButtonFragment on MemberGroup {\n  id\n  name\n  productId\n}\n\nfragment DeleteSubGroupButtonFragment on MemberGroup {\n  id\n  name\n  productId\n  parentMemberGroupId\n}\n\nfragment EditMemberGroupButtonFragment on MemberGroup {\n  id\n}\n\nfragment GroupsListChildGroupRowFragment on MemberGroup {\n  id\n  kind\n  createdAt\n  ...DeleteSubGroupButtonFragment\n  ...EditMemberGroupButtonFragment\n  ...MemberGroupTagFragment\n  ...MemberGroupVisibilityChipFragment\n  ...MemberGroupKindChipFragment\n  product {\n    name\n    id\n  }\n  parentMemberGroup {\n    name\n    id\n  }\n  memberGroupMemberships {\n    totalCount\n  }\n}\n\nfragment MemberGroupKindChipFragment on MemberGroup {\n  isSystem\n}\n\nfragment MemberGroupTagFragment on MemberGroup {\n  id\n  name\n  kind\n  color\n  role\n  isSystem\n  product {\n    id\n    name\n  }\n}\n\nfragment MemberGroupVisibilityChipFragment on MemberGroup {\n  visibility\n}\n\nfragment ProfileAvatarFragment on User {\n  id\n  fullName\n  avatar\n  isTest\n}\n\nfragment ProfileListModalListItemFragment on User {\n  id\n  firstName\n  lastName\n  fullName\n  ...ProfileAvatarFragment\n}\n\nfragment UnassignedCreateMemberGroupButtonFragment on MemberGroup {\n  id\n}\n\nfragment UnassignedMemberRowFragment on MemberGroup {\n  __typename\n  id\n  productId\n  ...UnassignedCreateMemberGroupButtonFragment\n  unassignedMembers {\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "abbca0ef6520a589d1bac076deb694d0";

export default node;
